import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Header } from "@/components/layout/Header";
import { VideoWorkspace } from "@/components/video/VideoWorkspace";
import { useAuthState } from "@/hooks/useAuthState";
import { useVideoSubmission } from "@/hooks/useVideoSubmission";

const Index = () => {
  const [hasSubmittedUrl, setHasSubmittedUrl] = useState(false);
  const [videoId, setVideoId] = useState<string | null>(null);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { isAuthenticated, userName } = useAuthState();
  const { handleVideoSubmit } = useVideoSubmission();

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    navigate("/landing");
  };

  const handleUrlSubmit = async (submitted: boolean, newVideoId: string) => {
    setHasSubmittedUrl(submitted);
    setVideoId(newVideoId);

    if (submitted && isAuthenticated) {
      await handleVideoSubmit(newVideoId);
    }
  };

  useEffect(() => {
    const urlVideoId = searchParams.get("video");
    if (urlVideoId) {
      setVideoId(urlVideoId);
      setHasSubmittedUrl(true);
    }
  }, [searchParams]);

  useEffect(() => {
    const checkAuth = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        navigate("/auth");
      }
    };
    checkAuth();
  }, []);

  if (isAuthenticated === false) {
    return null;
  }

  return (
    <div className="min-h-screen bg-background">
      <Header userName={userName} onSignOut={handleSignOut} />
      <main className="container px-4 md:px-8 py-4 md:py-8">
        <VideoWorkspace
          hasSubmittedUrl={hasSubmittedUrl}
          videoId={videoId}
          onUrlSubmit={handleUrlSubmit}
          showChatByDefault={searchParams.get("showChat") === "true"}
        />
      </main>
    </div>
  );
};

export default Index;